import { View,Heading,Flex,Divider,Text } from '@aws-amplify/ui-react';
import Table from '../components/DataTable';
import ErrorAlert from '../components/ErrorMessage';
import Navbar from '../components/Navegation';
import React, { useState } from 'react';
import { Auth,API } from 'aws-amplify';
import '../styles/home.css';


/** 
 * Pagina principal de consulta  
 * @param {signOut} función de cerrar sesion del autenticador
 * @param {user} user 
 * @returns Estructura de la pagina inicial donde se puede realizar la consulta de clientes.
 */
function MainView({signOut,user}){
  
  //STATES

    /**
     * Estado que maneja los valores de busqueda que se estan ingresando en el input
     */
    const[busqueda, setBusqueda] = useState({
      docType:"Tipo Documento",
      docNumber:""
    });

    /**
     * Estado que maneja los datos obtenidos en la consulta
     */
    const[datos, setDatos] = useState([]);

    /**
     *  Estado que maneja el mensaje de error
     */ 
    const[mensajeError, setMensajeError] = useState('');
      
    /*
     * 
     */
    const[valoresError, setErroValue] = useState({
      title:"",
      message:""
    });

  //FUNCTIONS
  async function searchDocument(e){

    e.preventDefault();
    setDatos([]);
    setMensajeError('');
    if(busqueda.docType !== "Tipo Documento"){
      
      const authToken = await getAuthToken();
      const apiName = 'PROD';
      const path = `/prod/user/${busqueda.docNumber}/type/${busqueda.docType}`;
      const myInit = { headers: { 'Authorization' : authToken }, response: true};
  
      API.get(apiName, path, myInit).then((response) => {


        if(response.data === "No existe usuario con ese ID"){
          setDatos([]);
          setErroValue({
            ...valoresError,
            title:"Error en consulta:",
            message:`No existe un usuario identificado con el documento ${busqueda.docType} : ${busqueda.docNumber}` 
          });
          setMensajeError('Error');

        }else{
        
          if(response.data.FechaVencimiento !== ""){
            let vencimiento  = new Date(changeFormat(response.data.FechaVencimiento)).getTime();
            let fechaConsulta = new Date().getTime();
            if(vencimiento < fechaConsulta){
              response.data.EstadoCurso = "VENCIDO";
            }
          }

          const client = {
            id: response.data.ID,
            Type: response.data.SK,
            Nombre: response.data.Nombre,
            Empresa: response.data.Empresa,
            ARL: response.data.ARL,
            EPS: response.data.EPS,
            FechaRealizacion: response.data.FechaRealizacion,
            FechaVencimiento: response.data.FechaVencimiento,
            EstadoCurso: response.data.EstadoCurso,
            Planta: response.data.Planta
          }
          setDatos([client]);
          setMensajeError('');
        }
      })
      .catch((error) => {
        //API siempre que obtiene un codigo 500 lo capta como un error por lo que se envia aca
        if(error.response.data === "Por favor intente mas tarde"){
          setDatos([]);
          setErroValue({
            ...valoresError,
            title:"Error en la petición:",
            message:`Por favor intente mas tarde.`
          });
          setMensajeError('Error');
        }
      });  
    
    }
    else{
      setDatos([]);
      setErroValue({
        ...valoresError,
        title:"Error en la petición:",
        message:"Debe de rellenar la información necesaria para realizar la consulta."
      });
      setMensajeError('Error');
    }

    setBusqueda({
      ...busqueda,docType:"Tipo Documento",docNumber:""
    })
  } 
    

  /**
   * Obtener el token de la sesión para las peticiones
   * @returns el token o NULL en caso de un error
   */
  const getAuthToken = async () => {
    try {
      const session = await Auth.currentSession();
      return session.getIdToken().getJwtToken();
    } catch (error) {
      console.log(error);
      return null;
    }
  }

  /**
   * Actualiza los valores de la busqueda cada que cambian
   * @param {*} e evento que llama a la función 
   */
  const handleChange = (e)=>{
    setBusqueda({
      ...busqueda,[e.target.name]:e.target.value
    })
  }

/**
 * Reconstruye el formato de la fecha dd/mm/yyyy a mm/dd/yyyy
 *  @param {*} date cadena de caracteres representando al fecha
 */
  const changeFormat = (date)=>{
    let dateParts =  date.split("/");
    return dateParts[1]+"/"+dateParts[0]+"/"+dateParts[2];
  }

    return (
        <View className="home">
          <Navbar signOut={signOut}/>
          <Flex className="home-container" direction="column" padding="15px 10%" gap="8px">
            <Heading width="100%" textAlign="center" level={3} fontWeight="bold">
              CONSULTE EL ESTADO DE SU CURSO <br/>
              CONTRATISTAS SASS-BPM PEPSICO
            </Heading>
            <Divider size="large" orientation="horizontal" />
            <Flex direction="column" gap={0}>
              <Text fontSize="1.5rem"> Pasos para ingresar a verificar </Text>
              <ul>
                <li> <Text fontSize="1.2rem"> <span className='paso'> Paso 1:</span> Seleccione el tipo de documento de identidad.</Text></li>
                <li> <Text fontSize="1.2rem"> <span className='paso'> Paso 2:</span> Digite el numero de identidad.</Text></li>
                <li><Text fontSize="1.2rem"> <span className='paso'> Paso 3:</span> Haga uso del boton BUSCAR para obtener la informacion de la persona a consultar.</Text></li>
                <li><Text fontSize="1.2rem"> <span className='paso'> Paso 4:</span> Aparecera la informacion de interes.</Text></li>
              </ul>
            </Flex>
            <Flex direction="column">
              <form onSubmit={searchDocument} className='home-form'>
                <select name="docType" value={busqueda.docType} onChange={handleChange}>
                  <option disabled hidden>Tipo Documento</option>
                  <option value="CC">CC</option>
                  <option value="CE">CE</option>
                  <option value="NIT">NIT</option>
                  <option value="PP">PP</option>
                  <option value="PE">PE</option>
                </select>
      
                <input type="text"  name="docNumber" value={busqueda.docNumber} placeholder="No. Documento" onChange={handleChange}/>
                <button type='submit'>Buscar</button>
              </form>
              {datos.length > 0 && <Table values={datos} docType={busqueda.docType} docNumber={busqueda.docNumber} /> }
              {mensajeError && <ErrorAlert title={valoresError.title} message={valoresError.message}/>}
            </Flex>
          </Flex>
        </View>
    );
  }
  
  export default MainView;